import Page from './index';
import { authRoles } from 'app/auth';
export default {
settings: {
		layout: {
			config: {
				footer: false
			}
		}
	},
	auth: authRoles.agentAndAdmin,
	routes: [
		{
			path: '/services',
			exact: true,
			component: Page.Layout
		}
	]
};